import { client, request } from "./_base";
import { getFinancialYearSelected } from "./week";

const endpoint = "arrivaldata";

export interface ArrivalGroupedContainer {
  farmnumber: string; // comma separated list
  varieties: string; // comma separated list
  orchard: string; // comma separated list
  producerid: string;
  producer: string;
  containerno: string;
  consigneeid: string;
  consignee: string;
  consignmentref: string;
  pod: string;
  poddesc: string;
  vessel: string;
  salesref: string;
  coldweek: Date;
  etd: string; // 2025-07-08
  waybill: string;
  ata: Date;
  eta: Date;
  updated_eta: Date;
  arrival_id: number;
  status: number;
  status_description: string;
  average: number;
  comments: string;
  defects: string;
  claim: number;
  shippingCode: string;
  arrivalc: number;
  sale_arrived: number;
  sale_collected: number;
  arrival_updated_at: Date;
  shipment_week: string;
  shipped_market: string;
  target_market: string;
  variety_code: string;
  nocartons: number;
  palletSize: number;
  portfinal_description: string;
  commodity: string;
  countcode: string;
  brand: string;
  gradecode: string;
  pickingref: string;
  qualityscore: number;
}

export const arrivaldata = client(`${endpoint}`, (item) => ({
  ...item,
}));

export const arrivaldataGroupedContainer = async (): Promise<ArrivalGroupedContainer[]> => {
  const result = await request(`${endpoint}/ext/groupedcontainer/${getFinancialYearSelected()}`, {
    method: "GET",
  });
  const resp = await result.json();
  if (result.status == 500) {
    throw resp;
  }
  return resp.data;
};

export const arrivaldataByContainerProducerSalesRef = (container: string, producerid, salesref) => {
  const validateContainer = container && !container.includes("/") ? container : "0";
  return request(`${endpoint}/ext/bycontainerproducersalesref/${validateContainer}/${producerid}/${salesref}`, {
    method: "GET",
  })
    .then(async (result) => {
      if (result.status == 500) {
        const resp = await result.json();
        throw resp;
      }
      return result.json();
    })
    .then(({ data }) => {
      return data;
    });
};

export type UpdatedArrivalData = {
  arrival_id: number;
  note: string;
};

export const updateArrivalData = async (data: UpdatedArrivalData[]) => {
  const result = await request(`${endpoint}/ext/updateArrivalData`, {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (result.status == 500) {
    const resp = await result.json();
    throw resp;
  }
};
